import axios from 'axios';
import {
  CREATE_CONNECTION_FAILURE,
  CREATE_CONNECTION_SUCCESS,
  CREATING_CONNECTION, FETCH_CONNECTION,
  FETCH_CONNECTIONS_SUCCESS, FETCHING_CONNECTION,
  FETCHING_CONNECTIONS, UPDATE_CONNECTION_SUCCESS,
  UPDATING_CONNECTION, CHECKING_CONNECTION,
  CHECKING_CONNECTION_SUCCESS, RESET_FIELDS
} from './ConnectionsConstants';

const path = 'utm/v1/sftp/credentials';
const checkConnectionpath = 'check-connection';

const fetchingConnections = () => ({ type: FETCHING_CONNECTIONS });
const fetchConnectionsSuccess = connections => ({ type: FETCH_CONNECTIONS_SUCCESS, connections });
const creatingConnection = () => ({ type: CREATING_CONNECTION });
const createConnectionSuccess = () => ({ type: CREATE_CONNECTION_SUCCESS });
const createConnectionFailure = () => ({ type: CREATE_CONNECTION_FAILURE });
const fetchingConnection = () => ({ type: FETCHING_CONNECTION });
const fetchConnectionSuccess = connection => ({ type: FETCH_CONNECTION, connection });
const updateConnectionSuccess = connection => ({ type: UPDATE_CONNECTION_SUCCESS, connection });
const updatingConnection = () => ({ type: UPDATING_CONNECTION });
const checkingConnection = () => ({ type: CHECKING_CONNECTION });
const checkingConnectionSuccess = connectionResult => ({ type: CHECKING_CONNECTION_SUCCESS, connectionResult });
const resetFields = () => ({ type: RESET_FIELDS });

export const fetchConnections = () => dispatch => {
  dispatch(fetchingConnections());
  axios.get(path)
    .then(connectionsResponse => {
      dispatch(fetchConnectionsSuccess(connectionsResponse.data.data));
    })
    .catch(error => {
      throw error;
    });
};

export const addConnection = connection => dispatch => {
  dispatch(creatingConnection());
  axios.post(path, connection)
    .then(response => {
      if (response.status === 200) {
        dispatch(createConnectionSuccess());
        dispatch(fetchConnections());
      }
      else {
        dispatch(createConnectionFailure());
      }
    })
    .catch(error => { throw error; });
};

export const updateConnection = connection => dispatch => {
  dispatch(updatingConnection());
  const conn = { ...connection };
  if (conn.password === '***') {
    delete conn.password;
  }
  axios.put(path, connection)
    .then(response => {
      dispatch(updateConnectionSuccess(response.data.data));
    })
    .catch(error => { throw error; });
};

export const fetchConnection = connectionId => dispatch => {
  dispatch(fetchingConnection());
  axios.get(`${path}/${connectionId}`)
    .then(response => {
      const { id, label, description, userName, port, address } = response.data.data;
      dispatch(fetchConnectionSuccess({ id, label, description, userName, port, address }));
    })
    .catch(error => { throw error; });
};

export const checkConnection = connection => dispatch => {
  dispatch(checkingConnection());
  axios.post(`${path}/${checkConnectionpath}`, connection)
    .then(response => {
      dispatch(checkingConnectionSuccess(response));
    })
    .catch(error => { throw error; });
};

export const clearFields = () => dispatch => {
  dispatch(resetFields());
};



// WEBPACK FOOTER //
// ./src/redux/connections/ConnectionsActions.js